import React from 'react';

export const SvgOverview = (props) => (
  <svg
    overflow='hidden'
    viewBox='0 0 1236 653'
    xmlns='http://www.w3.org/2000/svg'
    width='100%'
    height='100%'
    {...props}
  >
    <defs>
      <clipPath id='Overview_svg__a'>
        <path d='M131 1494h1239v655H131z' />
      </clipPath>
    </defs>
    <g
      transform='matrix(.99793 0 0 .99758 -130.94 -1490.6)'
      clipPath='url(#Overview_svg__a)'
    >
      <path
        d='M133.5 1604.8c0-59.84 48.503-108.34 108.34-108.34h1017.3c59.84 0 108.34 48.5 108.34 108.34v433.32c0 59.84-48.5 108.34-108.34 108.34H241.84c-59.832 0-108.34-48.5-108.34-108.34z'
        fillRule='evenodd'
        stroke='#4472c4'
        strokeMiterlimit={8}
        strokeWidth={4.583}
      />
    </g>
    <g
      style={{
        fill: '#fff',
        strokeLinejoin: 'round',
        strokeWidth: 312.25
      }}
      aria-label='\u5168\u4F53\u56F3'
    >
      <path d='M305.12 216.75q-34.939 49.397-68.674 72.288h151.81q-39.759-21.686-83.132-72.288zm-79.517 79.517q-16.867 9.638-39.759 21.686l-12.048-25.301q81.927-34.939 120.48-109.64l26.506 3.614q9.638 3.615-1.205 6.024l-2.41 3.615q54.217 66.264 128.91 89.156l-12.047 26.506q-14.458-4.82-40.963-20.482v20.482h-71.083v40.963h78.312v22.89h-78.312v46.988h110.84v22.89h-245.78v-22.89h110.84V375.78h-78.312V352.89h78.312v-40.963h-72.288zM547.29 389.04q59.035-54.216 86.746-120.48h-75.903v-22.891h81.927v-60.24h22.891q9.638 1.205 1.205 7.229v53.01h86.746v22.892h-79.517q19.277 57.83 86.746 120.48l-16.867 24.096q-51.807-51.807-77.108-104.82v69.879h34.939v22.89h-34.94v59.036H640.06v-59.035h-31.325v-22.891h31.325v-69.88q-28.915 63.856-74.698 103.61zm9.638-189.15q-6.024 31.325-16.867 59.035 9.639 3.614 0 8.434v195.18h-24.096v-150.6q-8.433 18.072-21.686 31.325l-16.867-21.686q40.963-55.421 56.626-137.35l26.506 9.638q6.024 4.82-3.614 6.024zM928 287.84q-9.638-24.096-25.301-43.373l20.482-12.048q19.277 21.686 26.506 42.168zm97.589-66.264h-197.59v198.79h197.59zm0 233.73v-12.048h-197.59v14.458h-24.096v-259.03h245.78v256.62zm-74.698-110.84q31.325 15.662 59.035 37.349l-19.277 22.891q-26.506-22.891-57.831-38.554-27.71 27.711-78.312 46.987l-15.662-21.686q48.192-19.277 71.083-38.554-27.71-14.458-62.65-28.915l15.662-19.277q28.915 10.843 65.059 27.711 27.711-32.53 49.397-95.18l26.506 10.843q9.638 2.41-3.614 8.434-22.891 57.83-49.397 87.95zm-75.903-98.794q15.662 18.072 26.506 42.168l-21.686 13.253q-9.638-24.096-25.301-43.373z' />
    </g>
  </svg>
);
